export default "__VITE_ASSET__DtYYe$fJ__"